import { Injectable, inject } from "@angular/core";
import { environment } from "../../environments/environment";
import { ApiService } from ".././api.service";
import { UserService } from "../user.service";

@Injectable({
	providedIn: "root",
})
export class ProfileService {
	private apiService = inject(ApiService);
	private userService = inject(UserService);

	consents: any[] = [];
	consentsFetched: boolean = false;

	// ponytail: UserService.user is in-memory only and set solely during login, so it's empty
	// after a reload/app-resume/deep-link even with a valid session ticket. Refetch from the
	// backend in that case rather than leaving the profile form blank.
	getCurrentContact = () => {
		return this.apiService.GetContactWithRelatives().then((contact: any) => {
			if (contact) {
				this.userService.setUser(contact);
			}

			return contact;
		});
	};

	updateProfile = (
		name: string,
		surname: string,
		phone: string,
		countrycode: string,
	) => {
		return this.apiService.GetContactWithRelatives().then((contact: any) => {
			contact.Firstname = name;
			contact.Lastname = surname;

			if (contact.PhoneNumbers && contact.PhoneNumbers.length > 0) {
				contact.PhoneNumbers[0].Number = phone;
				contact.PhoneNumbers[0].Countrycode = countrycode;
			} else {
				contact.PhoneNumbers = [{ Number: phone, Countrycode: countrycode }];
			}

			return this.apiService.UpdateUser(contact).then((updated: boolean) => {
				if (updated) {
					this.userService.setName(name);
					this.userService.setSurname(surname);
					this.userService.setPhone(phone, countrycode);
				}

				return updated;
			});
		});
	};

	closeProfile = () => {
		return this.apiService.DeleteUserAccount().then((closed: boolean) => {
			if (closed) {
				const loginUrl = environment.UserLoginUrl;
				window.location.href = loginUrl;
			}

			return closed;
		});
	};

	getConsents = () => {
		if (!this.consentsFetched) {
			return this.fetchConsents();
		} else {
			return new Promise((resolve, _) => {
				resolve(this.consents);
			});
		}
	};

	revokeConsent = (type: any) => {
		return this.apiService.RevokeConsent(type).then((revoked: any) => {
			if (revoked) {
				this.fetchConsents();
				return revoked;
			}
		});
	};

	private fetchConsents = () => {
		return this.apiService.GetConsents().then((consents: any) => {
			this.consents = consents;
			this.consentsFetched = true;
			return this.consents;
		});
	};
}
